<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img src="https://www.meredith.com/sites/all/themes/meredith/logo.png" width="112" height="28">
      </a>

      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-start">
        <router-link class="navbar-item" to="/"><span class="icon"><i class="fas fa-home"></i></span>&nbsp;Home</router-link>
        <router-link class="navbar-item" to="/documentation"> Help </router-link>
        <router-link class="navbar-item" to="/about">About</router-link>
        <a class="navbar-item" href="https://jira.meredith.com/servicedesk/customer/portal/181/create/421" target="_blank"> Report an issue </a>

<!--        <div class="navbar-item has-dropdown is-hoverable" >-->
<!--          <a class="navbar-link"> More </a>-->
<!--          <div class="navbar-dropdown">-->
<!--            <router-link class="navbar-item" to="/"><span class="icon"><i class="fas fa-home"></i></span>&nbsp;Home</router-link>-->
<!--            <router-link class="navbar-item" to="/about">About</router-link>-->
<!--            <hr class="navbar-divider">-->
<!--            <router-link class="navbar-item" to="/documentation"> Documentation </router-link>-->
<!--            <a class="navbar-item" href="https://jira.meredith.com/servicedesk/customer/portal/181/create/421" target="_blank"> Report an issue </a>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="navbar-end">
        <div class="navbar-item">
          <div class="control has-icons-left">
            <input class="input is-small" type="text" placeholder="search" v-model="searchStr"
                   v-on:keyup.enter="serachRedirect">
            <router-link :to="{ name: 'search', query: { q: searchStr } }">
              <span class="icon is-small is-left"> <i class="fas fa-search" aria-hidden="true"></i></span>
            </router-link>
          </div>
          <div class="buttons" v-show="false">
            <a class="button is-light">
              Login
            </a>
          </div>          
          <button class="button is-white" v-on:click="isShowModal = true">Advanced Search</button>
          <button class="button is-white" v-if="!authState?.isAuthenticated" v-on:click="login()">Login</button>
          <button class="button is-white" v-if="authState?.isAuthenticated" v-on:click="logout()">Logout</button>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal" id="modal-lg" size="lg" v-bind:class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      <div class="modal-card ">
        <header class="modal-card-head headerwidth">
          <p class="modal-card-title">
            <button v-on:click="addNewData" class="button is-light"><i style="font-size:20px;color:#42B983;" class="fa">&#xf0fe;</i>&nbsp;Add Criteria</button>
          </p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <div class="modal-card-body modalheight">
          <form role="form" id="advSearchform" @submit="getSearch">
            <div v-for="(data, index) in advance_search_data" :key="index">
              <select v-model="data.selectOption" id="mySelect" @change="getSearchType(data.selectOption, index),refreshOnChangePage(index)" class="select is-medium-type" required>
                <option disabled selected value="">Select Criteria</option>
                <option v-for="(criteria, ind) in data.arrCriteria" :key="ind" :value="criteria[0]">{{criteria[0]}}</option>
              </select>&nbsp;
              <i v-if="data.selectOption === 'Publications' "  >
                <div class="multiselect is-medium" v-on:keyup.enter="showSearch">
                  <div class="selectBox" v-on:click="showCheckboxes">
                    <select v-model="whitelisted_brands_dict" class="select is-medium-pub" style="font-style: normal;">
                    </select>
                    <div class="overSelect" v-if="checkboxselected.length === 0" style="font-style: normal;">Select publication(s) from list</div>
                    <div class="overSelect" v-else style="font-style: normal;">{{checkboxselected.toString()}}</div>
                  </div>
                  <div id="checkboxes" style="font-size: smaller; width: 60%; position: absolute; z-index:999; background-color: #FFFFFF; height: 75px; overflow: auto;">
                    <div v-for="(key, value) in whitelisted_brands_dict" v-bind:key="key" style="font-style: normal;">
                      <label :for=key>
                        &nbsp;<input type="checkbox" :id="key" v-on:click="getCheckboxclick(value)" style="font-style: normal;"/>&nbsp;{{value}}</label>
                    </div>
                  </div>
                </div>
              </i>
              <i v-else-if="data.selectOption === 'Date Is' || data.selectOption === 'Date After' || data.selectOption === 'Date Before' ">
                <input v-model="data.value" type="date" class="input is-medium" style="margin-bottom:15px; font-size: 1rem; height: 35px; width:65%" v-on:keyup.enter="triggerSearch" required>&nbsp;
              </i>
              <i v-else>
                <input v-model="data.value" class="select is-medium" size="39" style="margin-bottom: 15px;font-size: 1rem;" v-on:keyup.enter="triggerSearch" required>&nbsp;
              </i>
              <i class="btn btn-danger" style="float:right;" v-on:click="popThisData(index)">
                <i class="fa fa-minus-circle" style="color:red;"></i>
              </i>
            </div>
            <footer class="modal-card-foot footerwidth">
              <button type="submit" class="button is-success" style="background-color: #42B983;">Search</button>
              &nbsp;<button type="button" class="button" v-on:click="isShowModal = false">Cancel</button>
            </footer>
          </form>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'NavBar',
  data () {
    return {
      searchStr: '',
      isShowModal: false,
      advance_search_data: [ {
        selectOption: '',
        message: '',
        arrCriteria: [ ['Search', '1'], ['Publications', '2'], ['Date Before', '3'], ['Date Is', '4'], ['Date After', '5'], ['Headline', '6'], ['Deck/Lead', '7'], ['Byline', '8'], ['Caption', '9'], ['Section', '9'] ]
      }],
      expanded: false,
      checkboxselected: [],
      searchParamVal: '',
      searchType: [],
      advancedSearchKeyword: '',
      typeSelected: '',
      whitelisted_brands_dict: {
        'Allrecipes': '57d772c4311cdd29de5a86676f189c38',
        'All You': '49e60428570a609066fab5fa4021d3fc',
        'Better Homes & Gardens': 'a3c7cb234cac2d6c9d57a1cae0e748a6',
        'Business 2.0': 'b496baf7bc768078e47a337087f71ed6',
        'Coastal Living': 'b494859f2323f8535dc15df547f2e8df',
        'Cooking Light': '208ef5ec7e138fb2e9f40668a9364589',
        'Country Gardens': 'cf0328c1334afdab66f5cbb333684c7c',
        'Diabetic Living': '9e5a22e4a8aa6141751d9d82732467f1',
        'Do It Yourself': '990f5dab30fb2a0cdeaf94a40deb74d0',
        'Eating Well': '274d76506d92bdcfa2c4d3c2ca255043',
        'Entertainment Weekly': 'b06ab434f3ac747210f0a83a77e6ef75',
        'Family Circle': '69beabfbebedef5336475da7bf07e57e',
        'Fine Cooking': '8e67aa9f2e657d3b49a29d4127bea772',
        'Food & Wine': 'c84a254a82017abff0d5e695cfdca415',
        'Health': '32a2f3e0dee8d733d4209c5752423859',
        'Homes & Gardens': 'c8c71147a8e83c2b93b5ff4557028096',
        'InStyle': 'c3edc06c3a4a9e103f4c76a28d08abda',
        'Life': '2920fa3cc18179e973eeaf1a6fe9728c',
        'Martha Stewart Living': '3f5f1985abb8aa9e46f4705e18ecfb5c',
        'Midwest Living': 'c8d103d9fa7eedc84c4592887699f092',
        'Millie': 'd9be71b30159aabef6c56d4b556f0806',
        'Parents': 'abc48d5cdff37c0cea0aeeba021621a0',
        'Parents Latina': '3434525fc30f00dc8b931f96df8c9b4b',
        'People': 'c60782e796be662c6177242f89351537',
        'People StyleWatch': '095769961482edee01a241e51a074103',
        'People en Español': '84da6d8bcd81b4b245416b4981c3f05a',
        'Rachael Ray In Season': 'c229372360f5f363d8f67e6da4b8d9a3',
        'Real Simple': '2e1094dd8d4f4f37d4ced9b4b261ed5f',
        'Reveal': '2ca191054a9deb36458977a8881903f8',
        'Shape': '651852f8d3dce4fb37fbef1f1d66df86',
        'Southern Living': '8a4b572bface1505fa5f5e39b9820184',
        'Successful Farming': '9d4aa6a9b5cc64b016446e3ca3f6f75e',
        'The Magnolia Journal': '947dd511206befafcbb58d84d8c28739',
        'Traditional Home': '5919e2220f81e1e39e51f1b8c6232bbc',
        'Travel + Leisure': '1dd937657e78fe5e715dbb8c5a3e1da0',
        'Wood': '36ee95fdbeb564068a938d5bfefd8531'
      }
    }
  },
  methods: {
    login () {
      this.$auth.signInWithRedirect({ originalUri: '/' })
    },
    async logout () {
      await this.$auth.signOut()
    },
    getSearch: function (e) {
      console.log(e.id)
      e.preventDefault()
      this.showSearch()
    },
    serachRedirect: function () {
      this.$router.push({ name: 'search', query: { q: this.searchStr } })
    },
    addNewData: function () {
      let isPublicationSelected = false; let isDateBeforeSelected = false; let isDateAfterSelected = false; let isDateIsSelected = false
      for (let i = 0; i < this.advance_search_data.length; i++) {
        let checkvalue = this.advance_search_data[i].selectOption
        if (checkvalue === 'Publications') {
          isPublicationSelected = true
        }
        if (checkvalue === 'Date Before') {
          isDateBeforeSelected = true
        }
        if (checkvalue === 'Date After') {
          isDateAfterSelected = true
        }
        if (checkvalue === 'Date Is') {
          isDateIsSelected = true
        }
      }
      let arrCriteria1 = [['Search', '1'], ['Headline', '6'], ['Deck/Lead', '7'], ['Byline', '8'], ['Caption', '9'], ['Section', '9']]
      if (!isPublicationSelected) {
        arrCriteria1.push(['Publications', '2'])
      }

      if (!isDateBeforeSelected) {
        arrCriteria1.push(['Date Before', '3'])
      }

      if (!isDateAfterSelected) {
        arrCriteria1.push(['Date After', '5'])
      }

      if (!isDateIsSelected) {
        arrCriteria1.push(['Date Is', '4'])
      }
      function Comparator (a, b) {
        if (a[1] < b[1]) return -1
        if (a[1] > b[1]) return 1
        return 0
      }
      arrCriteria1.sort(Comparator)
      this.advance_search_data.push({
        selectOption: '',
        message: '',
        arrCriteria: arrCriteria1
      })
      try {
        if (document.getElementById('checkboxes').style.display !== 'none') {
          document.getElementById('checkboxes').style.display = 'none'
        }
      } catch (e) {
        console.log('')
      }
    },
    refreshOnChangePage: function (index) {
      this.count = []
      console.log(index)
      for (let j = 0; j < this.advance_search_data.length; j++) {
        if (this.advance_search_data[j].selectOption === '') {
          this.count.push(j)
        }
      }
      if (this.count.length !== 0) {
        let x = 0
        while (this.count.length > x) {
          this.advance_search_data.splice(this.count[x] - x, 1)
          this.addNewData()
          x++
        }
      }
    },
    refreshPage: function (index) {
      this.count = []
      console.log(index)
      for (let j = 0; j < this.advance_search_data.length; j++) {
        if (this.advance_search_data[j].selectOption === '') {
          this.count.push(j)
        }
      }
      if (this.count.length !== 0) {
        for (let x = 0; x < this.count.length; x++) {
          try {
            this.advance_search_data.pop({
              selectOption: '',
              message: '',
              arrCriteria: ''
            })
          } catch (err) {
            console.log('')
          }
        }
        for (let x = 0; x < this.count.length; x++) {
          try {
            this.addNewData()
          } catch (err) {
            console.log('')
          }
        }
      }
    },
    popThisData: function (index) {
      let removeCriteria = this.advance_search_data.splice(index, 1)
      this.searchType.splice(this.searchType.indexOf(removeCriteria[0].selectOption), 1)
      if (removeCriteria[0].selectOption === 'Publications') {
        this.checkboxselected = []
      }
      this.refreshPage(index)
    },
    showCheckboxes: function () {
      var checkboxes = document.getElementById('checkboxes')
      if (!this.expanded) {
        checkboxes.style.display = 'block'
        this.expanded = true
      } else {
        checkboxes.style.display = 'none'
        this.expanded = false
      }
    },
    hideCheckboxes: function () {
      var checkboxes = document.getElementById('checkboxes')
      checkboxes.style.display = 'none'
      this.expanded = false
    },
    getCheckboxclick: function (value) {
      if (this.checkboxselected.includes(value)) {
        this.checkboxselected.splice(this.checkboxselected.indexOf(value), 1)
      } else {
        this.checkboxselected.push(value)
      }
    },
    getSearchType: function (value, index) {
      this.searchType[index] = value
    },
    showSearch: function (value) {
      this.searchParamVal = ''
      this.advancedSearchKeyword = ''
      this.typeSelected = ''
      console.log(this.advance_search_data)
      for (let i = 0; i < this.searchType.length; i++) {
        if (this.searchType[i] === 'Publications') {
          if (this.$store.state.activeBrandName !== '') {
            if (!this.checkboxselected.includes(this.$store.state.activeBrandName)) { this.checkboxselected.push(this.$store.state.activeBrandName) }
          }
          for (let i = 0; i < this.checkboxselected.length; i++) {
            if (i < this.checkboxselected.length - 1) {
              this.searchParamVal += this.whitelisted_brands_dict[this.checkboxselected[i]] + ','
            } else {
              this.searchParamVal += this.whitelisted_brands_dict[this.checkboxselected[i]]
            }
          }
          this.typeSelected += this.advance_search_data[i].selectOption
        } else if (this.searchType[i] === 'Search') {
          this.advancedSearchKeyword += this.advance_search_data[i].value + ' '
        } else if (this.searchType[i] === 'Byline') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += this.advance_search_data[i].selectOption
        } else if (this.searchType[i] === 'Deck/Lead') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += 'DeckLead'
        } else if (this.searchType[i] === 'Headline') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += 'Headline'
        } else if (this.searchType[i] === 'Caption') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += 'Caption'
        } else if (this.searchType[i] === 'Section') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += 'Section'
        } else if (this.searchType[i] === 'Date Is' || this.searchType[i] === 'Date Before' || this.searchType[i] === 'Date After') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += this.advance_search_data[i].selectOption.replace(' ', '')
        }
        if (this.searchType[i].length > 1 && this.searchType[i] !== 'Search') {
          this.typeSelected += '%7C'
          this.searchParamVal += '%7C'
        }
      }
      this.typeSelected = this.typeSelected.slice(0, -3)
      this.searchParamVal = this.searchParamVal.slice(0, -3)
      this.advancedSearchKeyword = this.advancedSearchKeyword.trim()

      if (this.$store.state.activeBrandName !== '' && !this.searchType.includes('Publications')) {
        this.typeSelected += '%7CPublications'
        this.searchParamVal += '%7C' + this.whitelisted_brands_dict[this.$store.state.activeBrandName]
      }
      this.isShowModal = false
      this.searchStr = ''
      if (this.advancedSearchKeyword === '' && this.typeSelected === '' && this.searchParamVal === '') {
        this.isShowModal = true
        alert('Please select any criteria!')
        return false
      }
      if (this.typeSelected === 'Publications' && this.searchParamVal === '') {
        this.isShowModal = true
        alert('Please select any publication!')
        return false
      }
      this.$router.push({ name: 'search', query: { q: this.advancedSearchKeyword !== '' ? this.advancedSearchKeyword : '', type: this.typeSelected !== '' ? this.typeSelected : '0', val: this.searchParamVal !== '' ? this.searchParamVal : '0' } })
    }
  },
  computed: {
    message: function () {
      return ''
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .navbar-menu a.router-link-exact-active {
    color: #42b983;
  }
  .multiselect {
    width: 300px;
    display: table-cell;
  }
  .select {
    display: inline-block;
  }
  .select.is-medium-type {
    font-size: 1rem;
    width: 30%;
  }
  .select.is-medium {
    font-size: 1rem;
    width: 65%;
  }
  .select is-medium-pub {
    font-size: 1rem;
    width: 150%;
    height: 45px;
  }
  .selectBox {
    position: relative;
    width: 100%;
    height: 100%;
    margin-bottom: 15px;
  }
  .selectBox select {
    width: 390px;
    height: 35px;
    font-weight: bold;
  }
  .overSelect {
    position: absolute;
    left: 5px;
    right: 0;
    top: 10px;
    bottom: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #checkboxes {
    display: none;
    border: 1px #a5a5a5 solid;
    margin-top: -15px;
    margin-left: 1px;
  }
  #checkboxes label {
    display: block;
  }
  #checkboxes label:hover {
    background-color: #1e90ff;
  }
  .modalheight {
    margin-bottom: -20px;
  }
  .footerwidth {
    width: 107%;
    height: 60px;
    margin-left: -18px;
  }
  .headerwidth {
    width: 104%;
    height: 60px;
    margin-left: -18px;
  }
</style>
